/* --------------------------------------------------------------------------------------
   xwProgress.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwProgress {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    //this.scope = {}
  }
  link(scope, elem, attrs) {
    elem.first().xrxprogressindicator(attrs)
  }
  static directiveFactory() {
    xwProgress.instance = new xwProgress()
    return xwProgress.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwProgress.directive.js